import TotalProposalContainer from './TotalProposalContainer'

export { TotalProposalContainer }
